import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptors } from "../../app/store/baseQueryWithReauth";
import type {
	SaveSpeakingFeedbackRequest,
	SpeakingFeedbackAttempts,
} from "./types/speakingFeedback";

// Define the RTK Query API
export const speakingFeedbackApi = createApi({
	reducerPath: "speakingFeedbackApi",
	baseQuery: baseQueryWithInterceptors,
	tagTypes: ["SpeakingFeedback"],
	endpoints: (builder) => ({
		// Endpoint for saving speaking feedback
		saveSpeakingFeedback: builder.mutation<void, SaveSpeakingFeedbackRequest>({
			query: (feedbackData) => ({
				url: "speakingFeedback/saveSpeakingFeedback",
				method: "POST",
				body: feedbackData,
			}),
			invalidatesTags: [{ type: "SpeakingFeedback", id: "LIST" }],
		}),

		// Endpoint for fetching feedback by user
		getSpeakingFeedbackByUser: builder.query<
			SpeakingFeedbackAttempts[],
			{ userId: string; speakingActivityId: string }
		>({
			query: (data) => ({
				url: `speakingFeedback/getSpeakingFeedbackByUser?userId=${data.userId}&speakingActivityId=${data.speakingActivityId}`,
				method: "GET",
			}),
			providesTags: (result) =>
				result
					? [
							...result.map(({ _id }) => ({
								type: "SpeakingFeedback" as const,
								id: _id,
							})),
							{ type: "SpeakingFeedback", id: "LIST" },
						]
					: [{ type: "SpeakingFeedback", id: "LIST" }],
		}),
	}),
});

export const {
	useSaveSpeakingFeedbackMutation,
	useGetSpeakingFeedbackByUserQuery,
} = speakingFeedbackApi;
